import styled from 'styled-components';
import {
  Form,
} from 'antd';
import { COLOR_NEUTRAL_7, COLOR_NEUTRAL_2, COLOR_WHITE } from 'constants/colors';
import { Button } from 'UI';
import { CloseOutlined } from '@ant-design/icons';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const InlineButton = styled(Button)`
  display: inline-flex;
  width: auto;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
  }
`;

export const RemoteSelectContent = styled.div`
  position: relative;
`;

export const RemoteSelectSpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NotesInline = styled(BaseFormItem)`
  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 100%;
  }
`;

export const FormItemRow = styled.div`
  margin: 0;
  width: 100%;
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  padding-bottom: 1rem;

  & ${BaseFormItem.toString()} {
    padding-bottom: 0;
    max-width: 376px;
    flex: 1;
  }
`;

// Item Row

export const AddEntryItemButton = styled(Button)`
  width: 170px;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const RemoveEntryItemButton = styled(Button)`
  width: fit-content;
  background: transparent;
  border: 0;
  border-radius: 24px;
  box-shadow: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:active,
  &:focus {
    background: transparent;
  }
`;

export const RemoveEntryItemIcon = styled(CloseOutlined)`
  font-size: 24px;
  color: ${COLOR_NEUTRAL_7};
`;

export const EntryItemInput = styled(BaseFormItem)`
  width: 40%;
`;

export const EntryItemFormRow = styled.div`
  margin: 0;
  width: 100%;
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  padding: 0.5rem;

  &:nth-of-type(2n + 1) {
    background-color: ${COLOR_NEUTRAL_2};
  }

  & ${EntryItemInput.toString()} {
    padding-bottom: 0;
    max-width: 200px;
    flex: 1;
  }
`;

export const QuantityFormItem = styled(BaseFormItem)`
  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 150px;
  }
`;

export const PriceFormItem = styled(BaseFormItem)`
  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 150px;
  }
`;

export const SmallFormItem = styled(EntryItemInput)`
  max-width: 120px;
  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
  }
`;
